module.exports = __webpack_public_path__ + "static/media/d1ru.a2876f13.pdf";